import userIdentitySaga from './userIdentitySaga';
import userResultSaga from './userResultSaga';

export default [userIdentitySaga, userResultSaga];



// WEBPACK FOOTER //
// ./src/sagas/eternalSagas/index.js